import {
  CONFIRMATION_LINKED_RESOURCE_TYPES,
  type ConfirmationEntry,
} from "./confirmationEntryParser";
import type { FulfillmentOrderLine } from "../types";

/** 将共享资源录入结果映射为确认件计价口径，金额统一交给行池服务重算。 */
export function toFulfillmentLinePatch(
  entry: ConfirmationEntry,
): Partial<FulfillmentOrderLine> {
  const zeroAmount = /^0+(?:\.0+)?$/.test(entry.amount.trim());
  const pricingUnitType = entry.resourceType === "住宿"
    ? "room_night"
    : entry.resourceType === "餐"
      ? "person_meal"
      : entry.resourceType === "导游" || entry.unit === "人天"
        ? "person_day"
        : "unit";
  const supportsResourceReference = (
    CONFIRMATION_LINKED_RESOURCE_TYPES as readonly string[]
  ).includes(entry.resourceType);
  const defersResourceResolution = Boolean(entry.resourceSelection);

  return {
    resourceType: entry.resourceType,
    spuTableName: supportsResourceReference && !defersResourceResolution
      ? entry.spuTableName
      : null,
    spuId: supportsResourceReference && !defersResourceResolution ? entry.spuId : null,
    skuTableName: supportsResourceReference && !defersResourceResolution
      ? entry.skuTableName
      : null,
    skuId: supportsResourceReference && !defersResourceResolution ? entry.skuId : null,
    resourceSelection: entry.resourceSelection,
    ...(entry.resourceSelection?.kind === "stay"
      ? { fulfillmentSupplierId: null, fulfillmentSupplierName: null }
      : {}),
    itemNameSnapshot: entry.itemName,
    itemSpecSnapshot: entry.spec,
    serviceDateFrom: entry.serviceDates.at(0) ?? null,
    serviceDateTo: entry.serviceDates.at(-1) ?? null,
    dayExpression: entry.dayExpression,
    dayNumbers: entry.dayNumbers,
    serviceDates: entry.serviceDates,
    dateMappingStatus: entry.needsDateAdjustment ? "needs_adjustment" : "mapped",
    reviewStatus: "confirmed",
    travelerRole: entry.travelerRole,
    mealType: entry.mealType,
    ...(entry.resourceType === "导游" ? { providerAssignmentStatus: "assigned" } : {}),
    pricingUnitType,
    quantity: String(entry.quantity),
    billingCount: entry.billingCount,
    unit: entry.unit,
    unitPriceAmount: String(entry.unitPrice),
    remark: `快速录入：${entry.sourceText}${zeroAmount ? " 免费" : ""}`,
  };
}
